import { Backdrop, TextField, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import axios from "axios";
import { Link } from "react-router-dom";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import Loader from "../../components/Loader";
import sha512 from "crypto-js/sha512";
import { xCheckSumIdGernator } from "../../helper/helper";
import { Close, SentimentNeutral, Visibility } from "@mui/icons-material";
import moment from "moment";
import { Moment } from "./moment";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useFormik } from "formik";
import * as yup from "yup";
import OtpInput from "react-otp-input";
import Dropzone from "react-dropzone-uploader";
import UploadIcon from "@mui/icons-material/Upload";
import Swal from "sweetalert2";

export default function Verificationnnn() {
  const [timer, setTimer] = useState(0);
  const [timer1, setTimer1] = useState(0);
  const [fileButton, setFileButton] = useState(false);
  const [otpStart, setOptStart] = useState(false);
  const [display, setDisplay] = useState("d-none");
  const [display4, setDisplay4] = useState("d-none");
  const [file, setFile] = useState([]);
  const [open, setOpen] = useState(false);
  const [otp, setOtp] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [documents, setDocuments] = useState(false);
  const [useEffectCall, setUseEffectCall] = useState(false);
  const [otpStatus, setOtpStatus] = useState(false);
  const [submitField, setsubmitField] = useState(false);
  const [verifiedStatus, setverifiedStatus] = useState(false);
  const [display2, setDisplay2] = useState(false);
  const [display3, setDisplay3] = useState("d-none");
  const [otpValue, setOtpValue] = useState("");
  const [elsestate, setelsestate] = useState("");
  const [truesatte, settruesatte] = useState(false);
  const [disabledEmail, setdisabledEmail] = useState(false);
  const [message, setMessage] = useState("");
  const [message1, setMessage1] = useState(false);

  const parseData = JSON.parse(localStorage.getItem("details"));

  const tokken = localStorage.getItem("tokemtemp");

  const verificationDatee = parseData?.otpSentDate;
  const approvedDate = parseData?.otpVerifiedDate;

  const usernamee = parseData?.username;

  const emailSentDate = parseData?.emailSentDate;
  const emailVerifiedDate = parseData?.emailVerifiedDate;

  const otpVerficationStatus = parseData?.otpVerification;

  const emaildata = parseData?.emailSentDate;

  const documentList = parseData?.documentList;

  const emailsentdata = emaildata;

  const otpStatusagain = localStorage.getItem("otpstatus");

  const cpId = parseData?.uid;
  const customId1 = "custom-id-yess";

  const timeOutCallback = useCallback(
    () => setTimer((currTimer) => currTimer - 1),
    []
  );
  const timeOutCallback1 = useCallback(
    () => setTimer1((currTimer) => currTimer - 1),
    []
  );

  const handleChanges = (e) => {
    setOtpValue(e.target.value);
  };

  useEffect(() => {
    timer > 0 && setTimeout(timeOutCallback, 1000);
  }, [timer, timeOutCallback]);
  useEffect(() => {
    timer1 > 0 && setTimeout(timeOutCallback1, 1000);
  }, [timer1, timeOutCallback1]);

  const resetTimer = function () {
    if (!timer) {
      setTimer(29);
    }
  };
  const resetTimer1 = function () {
    if (!timer1) {
      setTimer1(29);
    }
  };

  useEffect(() => {
    if (verifiedStatus == true) {
      setDisplay2("d-none");
    } else {
      setDisplay2("");
    }
  }, [verifiedStatus]);

  useEffect(() => {
    if (timer == 0) {
      setDisplay("d-none");
    } else {
      setDisplay("");
    }
  }, [timer]);
  useEffect(() => {
    if (timer1 == 0) {
      setDisplay4("d-none");
    } else {
      setDisplay4("");
    }
  }, [timer1]);
  const handleChangeStatus = ({ meta, file }, status) => {
    // console.log(status, meta, file);
  };

  // receives array of files that are done uploading when submit button is clicked
  const handleSubmit = (files, allFiles) => {
    // console.log(files.map((f) => f.meta));
    allFiles.forEach((f) => f.remove());
  };
  const getUploadParams = ({ meta }) => {
    return { url: "https://httpbin.org/post" };
  };

  // useEffect(() => {
  //   if (display3 == false) {
  //     setDisplay3("d-none");
  //   } else {
  //     setDisplay3("");
  //   }
  // }, [display]);

  const callUseeffect = () => {
    setUseEffectCall(true);
  };
  const callUseeffectfalse = () => {
    setUseEffectCall(false);
  };

  const documentPendng = parseData?.documentList;

  const handleChange = (event, filee) => {
    // console.log({ event, file });

    setFile({
      ...file,
      [filee.documentType]: event.target.files[0],
      [`${filee.documentType}Name`]: URL.createObjectURL(event.target.files[0]),
    });
  };

  const accountStatus = async () => {
    try {
      setOpen(true);
      const res = await axios(
        `${process.env.REACT_APP_COMMON_API}/admin/v1/account/verification/status`,
        {
          headers: {
            Authorization: `Bearer ${tokken}`,
            userId: localStorage.getItem("userId"),
            source: "web",
          },
        }
      );

      // console.log(res.data);
      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
      } else {
        await setMessage(res.data.statusDescription.description);
        setOpen(false);
      }
    } catch (err) {
      // console.log(err);
      setOpen(false);
    }
  };

  // console.log(message, "helli thos is mkess");

  useEffect(() => {
    accountStatus();
  }, []);

  const fetchDocuments = async () => {
    try {
      setOpen(true);
      const res = await axios(
        `${process.env.REACT_APP_COMMON_API}/admin/v1/fetch/user/document/type`,
        {
          headers: {
            Authorization: `Bearer ${tokken}`,
            userId: cpId,
            source: "web",
          },
        }
      );
      // console.log(res.data.userDocTypeList);
      setDocuments(res.data.userDocTypeList);
      const status = res.data.statusDescription.statusCode;
      if (status == 200) {
        setOpen(false);
      } else {
        setOpen(false);
      }
    } catch (error) {
      // console.log(error);
      setOpen(false);
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, []);
  const fileSubmit = async (e, index) => {
    // console.log({ index });
    let object = {};
    // console.log(file.documentType, "file balue");
    e.preventDefault();
    // console.log(index.documentType);
    object[index.documentType] = false;
    const formData = new FormData();
    formData.append("file", file[index.documentType]);
    formData.append("cpId", cpId);
    formData.append("docType", index.documentType);

    setsubmitField(object);

    try {
      setOpen(true);
      // console.log(`Bearer ${tokken}`);
      const res = await axios.post(
        `${process.env.REACT_APP_COMMON_API}/admin/v1/document/upload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${tokken}`,
            userId: cpId,
            source: "web",
          },
        }
      );
      // console.log(res.data, "fuileupload data");

      const status = res.data.statusDescription.statusCode;
      if (status == 200) {
        setOpen(false);
        setFileButton(true);
        const element = document.getElementById(`disab${index.id}`);
        element.setAttribute("disabled", "");
        // setButtonDisabled(true == index.id);
        setTimeout(async () => {
          // await toast.success(res.data.statusDescription.description, {
          //   theme: "colored",
          // });
          Swal.fire({
            icon: "success",
            // title: "Oops...",
            text: res.data.statusDescription.description,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 100);
      } else {
        setOpen(false);
        setTimeout(async () => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.description,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 100);
      }
    } catch (err) {
      setOpen(false);
      // console.log(err);
      setTimeout(async () => {
         Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
      }, 100);
    }
  };

  // console.log({ buttonDisabled });

  // console.log({ fileButton });
  const verifyEmail = async (e) => {
    e.preventDefault();
    try {
      setOpen(true);
      const xCheckSumValues = xCheckSumIdGernator();
      // console.log(xCheckSumValues, "to srtring");
      const res = await axios(
        `${
          process.env.REACT_APP_COMMON_API
        }/auth/v1/email/verification/${localStorage.getItem("tokemtemp")}`
      );

      if (res.data.statusDescription.statusCode == 200) {
        // await toast.success(res.data.statusDescription.description, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "success",
          // title: "Oops...",
          text: res.data.statusDescription.description,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        setOpen(false);
      } else {
        // await toast.error(res.data.statusDescription.description, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.description,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        setOpen(false);
      }
    } catch (error) {
      setOpen(false);
        Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
      // console.log(error);
    }
  };

  const sendVerificationEmail = async () => {
    setOpen(true);
    try {
      const xCheckSumValues = xCheckSumIdGernator(parseData?.email);
      const res = await axios.post(
        `${process.env.REACT_APP_COMMON_API}/auth/v1/send/verification/email/`,
        {
          userId: localStorage.getItem("userId"),
          email: parseData?.email,
          requestId: xCheckSumValues.generator,
          isDebug: false,
        },
        {
          headers: {
            "X-CHECKSUM-ID": xCheckSumValues.allValuesHashed,
          },
        }
      );

      if (res.data.statusDescription.statusCode == 200) {
        setdisabledEmail(true);
        // await toast.success(
        //   "Verification Mail Sent !! Please Check Your MailBox",
        //   {
        //     theme: "colored",
        //   }
        // );
        Swal.fire({
          icon: "success",
          // title: "Oops...",
          text:  "Verification Mail Sent !! Please Check Your MailBox",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        setOpen(false);
      } else {
        // await toast.error(res.data.statusDescription.description, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.description,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        setOpen(false);
      }
    } catch (error) {
      // console.log(error);
       Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
      setOpen(false);
    }
  };

  const modelButtonApprove = useRef();
  const modelButtonApproveClose = useRef();
  const modelButtonApprove1 = useRef(null);
  const modelButtonApprove1Close = useRef(null);

  const alreaddyOtpButtonModel = async () => {
    await modelButtonApprove.current.click();
  };

  // const useEffectbutton = useRef(null);
  // const useEffectButtoncall = async (e) => {
  //   await useEffectbutton.current.click();
  // };

  // const resendbuttonModel = async () => {
  //   await modelButtonApprove1.current.click();
  // };

  const resendOtp = async () => {
    try {
      setOpen(true);
      const generator = Math.floor(Math.random() * 100000000);
      const allValues = `${parseData.mobile}${generator}54IzSRi`;
      const allValuesHashed = sha512(allValues).toString();
      const res = await axios.post(
        `${process.env.REACT_APP_COMMON_API}/auth/v1/pin/generate`,

        {
          msisdn: Number(parseData.mobile),
          // msisdn: 917033332311,
          requestId: generator,
          isDebug: false,
        },
        {
          headers: {
            "X-CHECKSUM-ID": allValuesHashed,
          },
        }
      );
      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        setMessage1(true);
        localStorage.setItem("transactionId", res.data.transactionId);
        localStorage.setItem("msisdn", res.data.msisdn);
        // await toast.success("OTP Sent Successfully", {
        //   theme: "colored",
        //   customId1,
        // });
        Swal.fire({
          icon: "success",
          // title: "Oops...",
          text:"OTP Sent Successfully",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        await setDisplay3("");
      } else {
        setOpen(false);
        // await toast.error(res.data.statusDescription.description, {
        //   theme: "colored",
        //   customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.description,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
      // console.log(res.data);
    } catch (error) {
      // console.log(error);
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };
  function openFullscreen(index) {
    document.getElementById(`image${index}`)?.requestFullscreen();
  }
  function openFullscreen2(index) {
    document.getElementById(`ifrasmee${index}`)?.requestFullscreen();
  }
  // function disabledB(ids) {
  //   console.log({ ids });
  //   document.getElementById(`image${ids}`)?.setAttribute("disabled", "");
  // }
  // const responseive = (ids) => {
  //   const element = document.getElementById(`disab${ids}`);
  //   element.setAttribute("disabled", "");
  // };

  // ✅ Set disabled attribute

  // useEffect(() => {
  //   if (otpStatusagain == "false" || "null") {
  //     setOtpStatus(true);
  //   } else {
  //     setOtpStatus(false);
  //   }
  // }, [otpStatusagain]);

  // useEffect(() => {
  //   if (localStorage.getItem("otpstatus") != "true") {
  //     // resendOtp();
  //   }
  // }, []);

  const verifyOtp = async (e) => {
    e.preventDefault();

    try {
      const generator = Math.floor(Math.random() * 100000000);
      const allValues = `${localStorage.getItem(
        "transactionId"
      )}${generator}54IzSRi`;
      const allValuesHashed = sha512(allValues).toString();

      setOpen(true);
      const res = await axios.post(
        `${process.env.REACT_APP_COMMON_API}/auth/v1/pin/verify`,
        {
          msisdn: `${localStorage.getItem("msisdn")}`,
          otp: otpValue,
          transactionId: `${localStorage.getItem("transactionId")}`,
          requestId: generator,
          isDebug: false,
        },
        {
          headers: {
            "X-CHECKSUM-ID": allValuesHashed,
          },
        }
      );
      // console.log(res.data.userDetail.otpVerification,"347");

      if (res.data.statusDescription.statusCode == 200) {
        modelButtonApproveClose.current.click();
        // localStorage.setItem("details",res.data.userDetail)
        await setverifiedStatus(true);

        // await toast.success("Otp Verified SuccessFully", {
        //   theme: "colored",
        // });

        Swal.fire({
          icon: "success",
          // title: "Oops...",
          text:"Otp Verified SuccessFully",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        setOtpValue("");

        // setSubmitDiv(true);

        setOpen(false);
      } else {
        await settruesatte(true);
        await setelsestate(res.data.statusDescription.description);

        setOtpValue("");

        setOpen(false);
      }
    } catch (error) {
      setOpen(false);
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  // console.log(otpValue.length);

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
  });

  return (
    <>
      <div className="container-fluid">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
        >
          <Loader />
        </Backdrop>
        <ToastContainer autoClose={6000} />
        <ThemeProvider theme={theme}>
          <form onSubmit={verifyOtp}>
            <div>
              <button
                ref={modelButtonApprove}
                type="button"
                className="btn btn-primary d-none"
                data-bs-toggle="modal"
                data-bs-target="#staticBackdrop"
              >
                Launch static backdrop modal
              </button>

              <div
                className="modal fade"
                id="staticBackdrop"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabindex="-1"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="staticBackdropLabel">
                        Verify Your Mobile Number
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => {
                          setOtpValue("");
                          settruesatte(false);
                        }}
                      ></button>
                    </div>
                    <div className="modal-body">
                      {/* <TextField
                        required
                        className="w-100"
                        label="Enter Your OTP"
                        name="otp"
                        variant="outlined"
                        size="small"
                        type="number"
                        value={formik.values?.otp}
                        onChange={formik.handleChange}
                        error={formik.touched.otp && Boolean(formik.errors.otp)}
                        helperText={for
                          mik.touched.otp && formik.errors.otp}
                      /> */}

                      {truesatte == true && (
                        <div class="alert alert-danger text-white" role="alert">
                          {elsestate}
                        </div>
                      )}
                      <div className="text-top" style={{ alignItems: "100px" }}>
                        <div className="w-100 d-flex justify-content-center">
                          {message1 == true ? (
                            <>
                              <label>Enter Your OTP Here :- </label>

                              <OtpInput
                                className=""
                                containerStyle={{
                                  height: 30,
                                }}
                                inputStyle={{
                                  color: "red",
                                  height: 50,

                                  width: 50,
                                }}
                                focusStyle={true}
                                value={otpValue}
                                onChange={(otp) => setOtpValue(otp)}
                                numInputs={4}
                                separator={<span>---</span>}
                                isInputNum={true}
                                hasErrored={true}
                              />
                            </>
                          ) : (
                            <>
                              <h6>Please Generate Otp First</h6>
                            </>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="modal-footer">
                      <button
                        type="button"
                        disabled={timer != 0}
                        className="btn btn-primary"
                        // data-bs-dismiss="modal"
                        onClick={() => {
                          settruesatte(false);
                          resetTimer();
                          resendOtp();
                        }}
                      >
                        Genrate OTP
                        <span className={`${display}`}>
                          {" "}
                          in:{timer} seconds
                        </span>
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-bs-dismiss="modal"
                        ref={modelButtonApproveClose}
                        onClick={() => {
                          setOtpValue("");
                          settruesatte(false);
                        }}
                      >
                        Close
                      </button>

                      {otpValue?.length >= 4 && (
                        <button
                          type="submit"
                          // disabled={otpValue.length < 4}
                          className="btn btn-primary"

                          // data-bs-dismiss="modal"
                        >
                          Confirm
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ThemeProvider>

        <div className="card mt-4">
          <div className="card-header border-0 d-flex d_flex_1 align-items-center p-3 pt-2">
            <i className="fas fa-user d-block i_8 mt_n4 p-4"></i>
            <div className="d-flex d_flex_2 ms-4 justify-content-between align-items-center w-100 mt_2">
              <p className="text-capitalize m-0 fw-bold">account status</p>

              {/* <div className="alert_8 d-flex d_flex align-items-center mt_2">
                {parseData?.otpVerification &&
                parseData?.requiredDocuments == null ? (
                  <div
                    className="alert alert-danger m-0 text-light"
                    role="alert"
                  >
                    Your Phone Number is Verified but Documents are Pending
                  </div>
                ) : parseData?.otpVerification != true &&
                  parseData?.requiredDocuments ? (
                  <div
                    className="alert alert-danger m-0 text-light"
                    role="alert"
                  >
                    Your Documents are Verified but Phone Number is Pending.
                  </div>
                ) : (
                  <div className="alert alert-danger m-0 mt_2" role="alert">
                    Your Account is still under verification and approval !!
                  </div>
                )}
              </div> */}
              <div className="alert_8 d-flex d_flex align-items-center mt_2">
                <div className="alert alert-danger m-0 text-light" role="alert">
                  {message}
                </div>
              </div>
              <div className="fw-bold d-flex align-items-center text-end align-right m-0">
                <div>Welcome :-{usernamee}</div>
                <Link to="/" className="d-block ms-4">
                  <button
                    type="button"
                    className="btn btn-primary align-right m-0"
                    onClick={() => {
                      localStorage.clear();
                    }}
                  >
                    Log Out
                  </button>
                </Link>
              </div>

              {/* <Link to="/" className="d-block">
                <button
                  type="button"
                  className="btn btn-primary align-right m-0"
                  onClick={() => {
                    localStorage.clear();
                  }}
                >
                  Log Out
                </button>
              </Link> */}
            </div>
          </div>
          <div className="card-body">
            <form>
              {" "}
              <div className="card card_8 mt-5">
                <div className="box_8 text-capitalize mt_n3 ms-5">
                  mobile Number Status
                </div>
                <div className="card-body">
                  <div className="row m_0 justify-content-between align-items-center">
                    <div className="col p_0">
                      <span className="d-block text-capitalize font-weight-bold">
                        phone number:
                      </span>
                      <span className="d-block  text-capitalize mt-2">
                        {parseData?.mobile}
                      </span>
                    </div>
                    <div className="col p_0 my_2">
                      <span className="d-block text-capitalize font-weight-bold">
                        OTP Sent date:
                      </span>

                      {parseData?.otpSentDate ? (
                        <span className="d-block i text-capitalize p-2 mt-2">
                          {moment(verificationDatee)?.format("lll")}
                        </span>
                      ) : (
                        <span className="d-block i text-capitalize mt-2">
                          -------------------------------
                        </span>
                      )}
                    </div>
                    <div className="col p_0">
                      <span className="d-block text-capitalize font-weight-bold">
                        OTP Verified date:
                      </span>
                      {parseData?.otpVerifiedDate ? (
                        <span className="d-block  text-capitalize p-2 mt-2">
                          {moment(approvedDate)?.format("lll")}
                        </span>
                      ) : (
                        <span className="d-block  text-capitalize mt-2">
                          -------------------------------
                        </span>
                      )}
                    </div>
                    <div className="col mt_2 p_0">
                      <span className="d-block spn text-capitalize font-weight-bold">
                        status
                      </span>
                      {/* {
                        verifiedStatus?.otpVerification?(

                        
                        <span className="badge badge_8 bg-success">
                        Approved
                      </span>
                    ) : (
                      <span className="badge badge_8 bg-warning me-auto">
                        Pending
                      </span>
                     
                    )} */}

                      {/* <div className="d-flex mt-2">
                        <span
                          className={
                            verifiedStatus
                              ? "badge badge_8 bg-success"
                              : "badge badge_8 bg-warning me-auto"
                          }
                        >
                          {verifiedStatus ? 'Approved'  : 'Pending'}
                        </span>
                      </div> */}
                      {/* 
                      <div className="d-flex mt-2">
                        <span
                          className={
                            verifiedStatus
                              ? "badge badge_8 bg-success"
                              : "badge badge_8 bg-warning me-auto"
                          }
                        >
                          {verifiedStatus ? 'Approved'  : 'Pending'}
                        </span>
                      </div> */}

                      <div className="d-flex mt-2">
                        {parseData?.otpVerification || verifiedStatus ? (
                          <span className="badge badge_8 bg-success">
                            <strong>Verified</strong>
                          </span>
                        ) : (
                          <span className="badge badge_8 bg-warning me-auto">
                            <strong>Verification Pending</strong>
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col">
                      {parseData?.otpVerification || verifiedStatus ? (
                        <>
                          <CheckCircleIcon
                            sx={{ color: "green", fontSize: "xxx-large" }}
                          />
                        </>
                      ) : (
                        <>
                          <div
                            className={`d-flex align-items-center${display2}`}
                          >
                            <button
                              type="button"
                              onClick={() => {
                                // resendOtp();
                                // resetTimer();
                                modelButtonApprove.current.click();
                                // formik.handleReset()
                                // setOtpValue("");
                                // settruesatte(false);
                                // callUseeffect();
                              }}
                              className="btn d-block w-auto bg-gradient-primary m-0"
                            >
                              Verify Mobile Number
                            </button>
                            {/* <div className={`${display3}`}>
                              <button
                                className="btn d-block w-auto bg-gradient-primary m-0 ms-2"
                                type="button"
                                onClick={() => {
                                  modelButtonApprove.current.click();
                                  settruesatte(false);
                                }}
                              >
                                Already have an OTP
                              </button>
                            </div> */}
                          </div>
                          {/* </div> */}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="card card_8 my-5">
                <div className="box_8 text-capitalize mt_n3 ms-5">
                  E-mail Verification
                </div>
                <div className="card-body">
                  <div className="row m_0 justify-content-between align-items-center">
                    <div className="col p_0">
                      <span className="d-block text-capitalize font-weight-bold">
                        e-mail:
                      </span>
                      <span className="d-block  text-capitalize mt-2">
                        {parseData?.email}
                      </span>
                    </div>
                    <div className="col p_0 my_2">
                      <span className="d-block text-capitalize font-weight-bold">
                        Email Sent date:
                      </span>
                      {parseData?.emailSentDate ? (
                        <span className="d-block  text-capitalize mt-2">
                          {moment(emailSentDate).format("lll")}
                        </span>
                      ) : (
                        <span className="d-block  text-capitalize mt-2">
                          -------------------------------
                        </span>
                      )}
                    </div>
                    <div className="col p_0">
                      <span className="d-block text-capitalize font-weight-bold">
                        Email Approved date:
                      </span>

                      {parseData?.emailVerifiedDate ? (
                        <span className="d-block  text-capitalize mt-2">
                          {moment(emailVerifiedDate).format("lll")}
                        </span>
                      ) : (
                        <span className="d-block  text-capitalize mt-2">
                          -------------------------------
                        </span>
                      )}
                    </div>
                    <div className="col mt_2 p_0">
                      <span className="d-block spn text-capitalize font-weight-bold">
                        status
                      </span>

                      <div className="d-flex mt-2">
                        {parseData?.emailVerification ? (
                          <span className="badge badge_8 bg-success">
                            <strong>Verified</strong>
                          </span>
                        ) : (
                          <span className="badge badge_8 bg-warning me-auto">
                            <strong>Verification Pending</strong>
                          </span>
                        )}
                      </div>
                    </div>
                    {parseData?.emailVerification ? (
                      <>
                        {" "}
                        <CheckCircleIcon sx={{ color: "green" }} />
                      </>
                    ) : (
                      <>
                        <div className="col">
                          <button
                            type="button"
                            disabled={timer1 != 0}
                            onClick={() => {
                              sendVerificationEmail();
                              resetTimer1();
                            }}
                            className="btn w-auto bg-gradient-primary m-0"
                          >
                            Resend Email
                            <span className={`${display4}`}>
                              {" "}
                              in:{timer1} seconds
                            </span>
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </form>
            {documents?.length > 0 && (
              <div className="card card_8 mt-5 ">
                {/* <div className="card shadow-none border bg_blue"> */}
                {/* <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                  Documents Status
                </span> */}
                <div className="box_8 text-capitalize mt_n3 ms-5">
                  Documents Status
                </div>
                <div className="card-body">
                  {documents &&
                    documents?.map((e, index) => {
                      {/* console.log(e.uploadDate, e, "upload date"); */}
                      return (
                        <form
                          className="m-0"
                          onSubmit={(ev) => {
                            fileSubmit(ev, e);
                          }}
                        >
                          <div className="row justify-content-between align-items-center">
                            <div className="col">
                              <label className="form-check-label d-block text-capitalize">
                                {e?.documentType}
                                {e?.mandatory && (
                                  <span className="red-star">*</span>
                                )}
                              </label>
                              {/* <span class="Drags">Drag and Drop Here</span>
                              <span class="Drags">Or</span> */}
                              <label
                                className="form-check-label d-block p-2 label_8 mt-2"
                                for="exampleInputfile1"
                              >
                                <input
                                  required
                                  accept="image/* ,.pdf"
                                  type="file"
                                  style={{ color: "#fffff" }}
                                  onChange={(ev) => {
                                    handleChange(ev, e);
                                  }}
                                  // className="form-control file_8"
                                  // className="form-control file_8"
                                  id="exampleInputfile1"
                                  aria-describedby="fileHelp"
                                />
                              </label>
                            </div>

                            <div className="col p_0 my_2">
                              <span className="d-block text-capitalize font-weight-bold">
                                Document Upload Date
                              </span>
                              {/* {parseData?.emailSentDate ? (
                                <span className="d-block  text-capitalize mt-2">
                                  {moment(e.uploadDate).format("lll")}
                                </span
                              ) : (
                                <span className="d-block  text-capitalize mt-2">
                                  -------------------------------
                                </span>
                              )} */}
                              {e?.uploadDate ? (
                                <span className="d-block  text-capitalize mt-2">
                                  {moment(e?.uploadDate).format("lll")}
                                </span>
                              ) : (
                                <span className="d-block  text-capitalize mt-2">
                                  -------------------------------
                                </span>
                              )}
                            </div>
                            <div className="col p_0 my_2">
                              <span className="d-block text-capitalize font-weight-bold">
                                Document Approved Date
                              </span>
                              {/* {parseData.emailSentDate ? (
                                <span className="d-block  text-capitalize mt-2">
                                  {moment(e.verifiedDate).format("lll")}
                                </span>
                              ) : (
                                <span className="d-block  text-capitalize mt-2">
                                  -------------------------------
                                </span>
                              )} */}
                              {e?.verifiedDate ? (
                                <span className="d-block  text-capitalize mt-2">
                                  {moment(e?.verifiedDate).format("lll")}
                                </span>
                              ) : (
                                <span className="d-block  text-capitalize mt-2">
                                  -------------------------------
                                </span>
                              )}
                            </div>
                            <div className="col mt_2 p_0">
                              <span className="d-block spn text-capitalize font-weight-bold">
                                status
                              </span>

                              <div className="d-flex mt-2">
                                {e?.approved == 0 ? (
                                  <span className="badge badge_8 bg-warning">
                                    <strong>Verification Pending</strong>
                                  </span>
                                ) : (
                                  <span className="badge badge_8 bg-success me-auto">
                                    <strong>Verified</strong>
                                  </span>
                                )}
                              </div>
                            </div>

                            {file[e?.documentType] &&
                            file[e?.documentType]?.name?.split(".")?.pop() ==
                              "pdf" ? (
                              <div className="col-md-2">
                                <iframe
                                  id={`ifrasmee${e.id}`}
                                  onClick={() => {
                                    openFullscreen2(e?.id);
                                  }}
                                  src={file[`${e?.documentType}Name`]}
                                  width="100%"
                                  frameborder="0"
                                  height="100px"
                                ></iframe>
                                <div
                                  className="mt-1"
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  {/* <button
                                    onClick={() => {
                                      openFullscreen2(e?.id);
                                    }}
                                  >
                                    
                                  </button> */}
                                  <Visibility
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      openFullscreen2(e?.id);
                                    }}
                                  />
                                </div>
                              </div>
                            ) : (
                              <>
                                <div className="col-md-1">
                                  <img
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      openFullscreen(e?.id);
                                    }}
                                    src={file[`${e?.documentType}Name`]}
                                    id={`image${e.id}`}
                                    height="50px"
                                    className="img-fluid d-block"
                                    // onClick={() => {
                                    //   setFile("");
                                    // }}
                                  />
                                </div>
                              </>
                            )}

                            {/* {fileButton == true ? (
                            <h3>Submitted Successfully</h3>
                          ) : ( */}
                            <>
                              <div className="col px-0 text-end">
                                <button
                                  // onClick={() => {
                                  //   console.log(e.id);
                                  //   responseive(e.id);
                                  // }}
                                  id={`disab${e.id}`}
                                  // disabled={buttonDisabled == true}
                                  type="submit"
                                  className="btn btn-primary btn_primary m-0"
                                  style={{ padding: "0.6rem 1.5rem" }}
                                >
                                  <UploadIcon />
                                  Upload File
                                </button>
                              </div>
                            </>
                            {/* )} */}
                          </div>
                        </form>
                      );
                    })}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
